import "./src/styles/global.css";
import "./i18";
import Layout from "@/components/Layout";
import React from "react";

const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export { wrapPageElement };